import '../sass/screen.scss'; // Import SASS for processing

jQuery(document).ready(function($) {



    $('#nav-toggle').click(function(){
        $('body').toggleClass('m-toggle');
    });   


    // -- faq accordion

    $('.faq header').click(function(){
        $(this).parent().toggleClass('active');
    });

  

    // -- header height
    const header = document.querySelector('.header');

    const getHeaderHeight = () => {

        // -- set timeout to allow for the header to render
        setTimeout(function() { 
        
            let headerHeight = header.offsetHeight;
    
            document.documentElement.style.setProperty('--header-height', (headerHeight - 18) + 'px');
    
        }, 500);
    
    };

    getHeaderHeight();

    // -- resize event
    window.addEventListener('resize', getHeaderHeight);



    // -- testislider 

    $('.testimonials__slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        arrows: true,
        fade: true,
        prevArrow:"<div class='anchor-action'><i class='fas fa-arrow-left' aria-hidden='true'></i></div>",
        nextArrow:"<div class='anchor-action'><i class='fas fa-arrow-right' aria-hidden='true'></i></div>",
        dots: false,
        appendArrows: $('.tcontrol-arrows'),
      });
    

        // -- Logos Slider
        $('.logos').slick({
            speed: 5000,
            autoplay: true,
            autoplaySpeed: 0,
            centerMode: true,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            infinite: true,
            initialSlide: 1,
            arrows: false,
            buttons: false
          });

          // slick for .galley with responsive breakpoints

          $('.gallery-dynamic').slick({
            
            autoplay: false,
            autoplaySpeed: 0,
            centerMode: false,
            cssEase: 'linear',
            slidesToShow: 4,
            slidesToScroll: 1,
            variableWidth: false,
            infinite: true,
            initialSlide: 1,
            arrows: true,
            prevArrow:"<div class='anchor-action'><i class='fas fa-arrow-left' aria-hidden='true'></i></div>",
            nextArrow:"<div class='anchor-action'><i class='fas fa-arrow-right' aria-hidden='true'></i></div>",
            dots: false,
            appendArrows: $('.gcontrol-arrows'),
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                  dots: false
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
          });





          $('.bio__open').bind('click', function(e){

             $(this).parent().parent().toggleClass('active');

             return false;

          });

          $('.bio__close').bind('click', function(e){

            $(this).parent().parent().parent().toggleClass('active');

            return false;
        
          });


     // -- set timeout to allow for the google maps api to load
    setTimeout(function() { 

      initMap();

    }, 1000);

    function initMap() {

  

      // -- look for #map its long is data attribute "data-lng" and its lat is data attribute "data-lat" and make a google map with a marker
     
       if($('#map').length) {
   
           var lat = $('#map').attr('data-lat');
           var lng = $('#map').attr('data-lng');
   
           var myLatLng = {lat: parseFloat(lat), lng: parseFloat(lng)};

           // creae a new map and use the custom style
            const map = new google.maps.Map(document.getElementById('map'), {
                zoom: 16,
                center: myLatLng,
                styles: mapStyle
            });
   
        
   
           const marker = new google.maps.Marker({
               position: myLatLng,
               map: map
           });
   
       } else {
         console.error("#map not found in the DOM.");
       }
   
   }


  const stickyElement = document.querySelector('.page-anchors--about');

  const viewportHeight = window.innerHeight;

  console.log( stickyElement );

  if( stickyElement ) {

    // -- work out on scroll where we are

    window.addEventListener('scroll', function() {

      let scrollY = window.scrollY;

      console.log( scrollY + ' ' + (viewportHeight/2) );

      if(scrollY > viewportHeight) {
        stickyElement.classList.add('stuck');
      } else {
        
        stickyElement.classList.remove('stuck');
      }

    });
  }



})


var mapStyle = [
  {
      "featureType": "all",
      "elementType": "labels",
      "stylers": [
          {
              "visibility": "on"
          }
      ]
  },
  {
      "featureType": "all",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "saturation": 36
          },
          {
              "color": "#000000"
          },
          {
              "lightness": 40
          }
      ]
  },
  {
      "featureType": "all",
      "elementType": "labels.text.stroke",
      "stylers": [
          {
              "visibility": "on"
          },
          {
              "color": "#000000"
          },
          {
              "lightness": 16
          }
      ]
  },
  {
      "featureType": "all",
      "elementType": "labels.icon",
      "stylers": [
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "administrative",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 20
          }
      ]
  },
  {
      "featureType": "administrative",
      "elementType": "geometry.stroke",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 17
          },
          {
              "weight": 1.2
          }
      ]
  },
  {
      "featureType": "administrative.country",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#ed5929"
          }
      ]
  },
  {
      "featureType": "administrative.locality",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#c4c4c4"
          }
      ]
  },
  {
      "featureType": "administrative.neighborhood",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#ffcb05"
          }
      ]
  },
  {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 20
          }
      ]
  },
  {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 21
          },
          {
              "visibility": "on"
          }
      ]
  },
  {
      "featureType": "poi.business",
      "elementType": "geometry",
      "stylers": [
          {
              "visibility": "on"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#ffcb05"
          },
          {
              "lightness": "0"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#000000"
          }
      ]
  },
  {
      "featureType": "road.highway",
      "elementType": "labels.text.stroke",
      "stylers": [
          {
              "color": "#ed5929"
          },
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 18
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#ffcb05"
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#000000"
          }
      ]
  },
  {
      "featureType": "road.arterial",
      "elementType": "labels.text.stroke",
      "stylers": [
          {
              "color": "#ffffff"
          },
          {
              "visibility": "off"
          }
      ]
  },
  {
      "featureType": "road.local",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 16
          }
      ]
  },
  {
      "featureType": "road.local",
      "elementType": "geometry.fill",
      "stylers": [
          {
              "color": "#666666"
          }
      ]
  },
  {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
          {
              "color": "#ffffff"
          }
      ]
  },
  {
      "featureType": "transit",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 19
          }
      ]
  },
  {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
          {
              "color": "#000000"
          },
          {
              "lightness": 17
          }
      ]
  }
];




document.addEventListener('DOMContentLoaded', function () {

    let currentDepth = 0;
    let hasSetup = false;

    function initNav() {

        // -- are we less than 1301px
        if( window.innerWidth > 1300 ) return;


        if (hasSetup) return;
        console.log( "init Nav" );
        setUpBackButtons();
        setUpClickHandlers();
        hasSetup = true;
    }

    const setUpClickHandlers = () => {
        let hasChild = document.querySelectorAll('.menu-item-has-children > a');

        hasChild.forEach(function (item) {
            item.addEventListener('click', function (event) {
                console.log('clicked');
                event.preventDefault();

                let parent = this.parentElement;
                let sub = parent.querySelector('.sub-menu');

                console.log(sub);
                sub.classList.add('active');
            });
        });
    };

    const setUpBackButtons = () => {
        let subs = document.querySelectorAll('.menu-item-has-children ul');

        subs.forEach(function (item) {

        
            let back = document.createElement('li');
            back.classList.add('back');
            back.innerHTML = '<button class="back"><i class="bx bx-chevron-left"></i> Back</button>';
            item.insertBefore(back, item.firstChild);

            
            back.addEventListener('click', function (event) {
                event.preventDefault();
                this.parentElement.classList.remove('active');
            });
        });
    };

    if (window.innerWidth < 1300) {
        initNav();
    }

    // -- need a resize event to check if we need to re-init the nav
    window.addEventListener('resize', function () {
        if (window.innerWidth < 1300 && !hasSetup) {
            initNav();
        }
    });



});


// -- [GLOBAL] on reszie get the header height and set it as a css var



const getHeaderHeight = () => {

    const header = document.querySelector('.header');

    // -- set timeout to allow for the header to render

    setTimeout(function() { 
    
        let headerHeight = header.offsetHeight;

        document.documentElement.style.setProperty('--header-height', (headerHeight - 18) + 'px');

    }, 1000);

};

document.addEventListener('DOMContentLoaded', function() {

    // -- add a JS class to the body
    document.body.classList.add('js');

    // -- get the header height and assign it as a VAR
    getHeaderHeight();

    window.addEventListener('resize', function() {
            
            getHeaderHeight();
    
    });

});